import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

import { usePaymentProviders } from '../hooks/use-payment-admin.js';

/** Shown across the admin portal while any store is set to a gateway it has no keys for —
 *  neither its own nor the platform's. Its customers can't pay online until that's fixed. */
export function PaymentProviderAlert() {
  const { data: providers } = usePaymentProviders();
  const broken = (providers ?? [])
    .filter((status) => !status.configured)
    .map((status) => ({
      ...status,
      stores: status.stores.filter((store) => !store.ownCredentials),
    }))
    .filter((status) => status.stores.length > 0);
  if (broken.length === 0) {
    return null;
  }

  return (
    <div className="flex items-start gap-2 border-b border-destructive/40 bg-destructive/10 px-4 py-2 text-sm text-destructive">
      <AlertTriangle className="mt-0.5 size-4 shrink-0" />
      <p>
        {broken.map((status) => (
          <span key={status.provider} className="block">
            {status.stores.map((store) => store.name).join(', ')}{' '}
            {status.stores.length === 1 ? 'uses' : 'use'} {status.label} but{' '}
            {status.stores.length === 1 ? 'has' : 'have'} no {status.label} keys (own or platform) —
            online payments there will fail.{' '}
          </span>
        ))}
        <Link to="/settings/payments" className="font-medium underline">
          See what&apos;s missing
        </Link>
      </p>
    </div>
  );
}

/** Settings › Payments' reminder for any gateway without platform keys — stores can still use
 *  it with their own keys. */
export function UnconfiguredProvidersNotice() {
  const { data: providers } = usePaymentProviders();
  const missing = (providers ?? []).filter((status) => !status.configured);
  if (missing.length === 0) {
    return null;
  }
  return (
    <div className="flex items-start gap-2 rounded-md border border-warning/40 bg-warning/10 p-3 text-sm">
      <AlertTriangle className="mt-0.5 size-4 shrink-0 text-warning" />
      <p>
        {missing.map((status) => status.label).join(' and ')}{' '}
        {missing.length === 1 ? 'has' : 'have'} no platform keys yet, so only stores with their own
        keys can use {missing.length === 1 ? 'it' : 'them'}. To set platform keys, add the secrets
        listed below in Secret Manager and redeploy the API.
      </p>
    </div>
  );
}
